import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
import DimensionsFragment from './Dimensions';
import FactSheetFragment from './FactSheet';
var Bundles = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment bundles on Bundle {\n    id\n    image\n    price\n    quantity\n    reference\n    title\n    dimensions {\n      ...dimensions\n    }\n    factsheet {\n      ...factsheet\n    }\n  }\n  ", "\n  ", "\n"])), DimensionsFragment, FactSheetFragment);
export default Bundles;